/* Papeterie Montparnasse - page de résultats « precision-first » (DEV, réversible).
   Couche ADDITIVE sur la section native `main-search` : aucune modif de
   main-search.liquid. On réorganise les cartes natives (product-card) en :
     * Meilleures correspondances = produits du prédictif (repli plein-texte
       via ?view=pm-json si le prédictif est vide) ;
     * Autres résultats = le reste, replié derrière un bouton.
   Le prédictif ne sert qu'à DÉCIDER où couper ; les cartes restent natives.
   Robuste : requête lue depuis l'URL, total depuis le titre natif, et on
   ATTEND l'apparition de la grille (cas Ajax multi-types). Auto-diagnostic
   dans la console (préfixe [PM-Search]). Amélioration progressive.
   Réversibilité : retirer le bloc search de theme.liquid + supprimer les assets. */
(function () {
  var TAG = '[PM-Search]';
  function log() { try { console.log.apply(console, [TAG].concat([].slice.call(arguments))); } catch (e) {} }

  log('script chargé', location.href);
  log('PM_SEARCH =', window.PM_SEARCH);

  function getQ() {
    try { var u = new URLSearchParams(location.search).get('q'); if (u) return u.trim(); } catch (e) {}
    if (window.PM_SEARCH && PM_SEARCH.terms) return String(PM_SEARCH.terms).trim();
    var inp = document.querySelector('.search-banner input[name="q"], .main-search-form input[name="q"]');
    return inp ? inp.value.trim() : '';
  }

  function getTotal(h1) {
    if (window.PM_SEARCH && parseInt(PM_SEARCH.count, 10) > 0) return parseInt(PM_SEARCH.count, 10);
    if (h1) { var m = h1.textContent.replace(/ /g, ' ').match(/\d[\d\s]*/); if (m) return parseInt(m[0].replace(/\D/g, ''), 10) || 0; }
    return 0;
  }

  function whenReady(cb) {
    function found() { return document.querySelector('.collection__results .product-list product-card, .collection__results .product-list .product-card, .product-list product-card, .product-list .product-card'); }
    if (found()) { log('grille produits présente au démarrage'); cb(); return; }
    log('grille produits absente - attente (Ajax ?)...');
    var done = false;
    var obs = new MutationObserver(function () {
      if (done) return;
      if (found()) { done = true; obs.disconnect(); log('grille produits apparue'); cb(); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { if (!done) { done = true; obs.disconnect(); log('grille toujours absente après 5 s - abandon'); } }, 5000);
  }

  function run() {
    try {
      var q = getQ();
      if (!q) { log('abandon : requête vide'); return; }

      var params = new URLSearchParams(location.search);
      var pg = params.get('page');
      if (pg && pg !== '1') { log('abandon : page', pg, '(séparation page 1 uniquement)'); return; }

      var results = document.querySelector('.collection__results');
      var list = document.querySelector('.product-list');
      if (!results || !list) { log('abandon : .collection__results ou .product-list introuvable', { results: !!results, list: !!list }); return; }

      var sec = document.querySelector('.shopify-section--main-search') || results.closest('.shopify-section') || results;
      var nativeStack = results.querySelector('.v-stack') || list.parentNode;
      var pagination = document.querySelector('.collection__pagination');
      var cards = [].slice.call(list.querySelectorAll('product-card, .product-card'));
      log('cartes trouvées :', cards.length);
      if (cards.length < 2) { log('abandon : moins de 2 cartes'); return; }

      var h1 = document.querySelector('.search-banner h1');
      var total = getTotal(h1) || cards.length;
      log('requête =', q, '| total =', total);

      if (sec && sec.querySelector && sec.querySelector('.pm-best-block')) { log('déjà appliqué'); return; }

      // Titre épuré.
      if (h1) { h1.classList.add('pm-search-title'); h1.innerHTML = 'Résultats pour <em>« ' + esc(q) + ' »</em>'; }

      var bestBlock = el('div', 'pm-block pm-best-block');
      bestBlock.innerHTML = '<div class="pm-eyb-line"><span class="pm-eyb">Meilleures correspondances</span></div><div class="pm-best"></div>';
      var bestGrid = bestBlock.querySelector('.pm-best');

      var sep = el('div', 'pm-elargir');
      sep.innerHTML = '<button type="button" class="pm-elargir__btn" aria-expanded="false">Voir les <span class="pm-n">autres résultats</span> <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></button>';

      var othersEyb = el('div', 'pm-block pm-others-eyb');
      othersEyb.innerHTML = '<div class="pm-eyb-line"><span class="pm-eyb">Autres résultats</span></div>';

      results.insertBefore(bestBlock, nativeStack);
      results.insertBefore(sep, nativeStack);
      results.insertBefore(othersEyb, nativeStack);

      // Pagination « Afficher plus de produits » (comme sur les collections) au lieu
      // des fleches natives : on reutilise le composant <pm-load-more> (pm-load-more.js).
      var nextLink = pagination ? pagination.querySelector('a[rel="next"]') : null;
      var loadmore = el('pm-load-more', 'pm-load-more');
      loadmore.setAttribute('data-next-url', nextLink ? (nextLink.getAttribute('href') || '') : '');
      loadmore.innerHTML = '<button type="button" class="pm-load-more__btn" data-pm-btn hidden>Afficher plus de produits</button><p class="sr-only" role="status" aria-live="polite" data-pm-status></p>';
      results.appendChild(loadmore);

      nativeStack.classList.add('pm-collapsed');
      othersEyb.classList.add('pm-collapsed');
      if (pagination) pagination.classList.add('pm-collapsed');
      loadmore.classList.add('pm-collapsed');
      // Option A : tant que seul le bloc « Meilleures correspondances » est
      // visible, on masque filtres + tri (pm-only-best). Ils reviennent avec
      // le catalogue complet quand on ouvre « Voir les autres resultats ».
      if (sec && sec.classList) sec.classList.add('pm-only-best');

      var btn = sep.querySelector('.pm-elargir__btn');
      btn.addEventListener('click', function () {
        var nowCollapsed = nativeStack.classList.toggle('pm-collapsed');
        othersEyb.classList.toggle('pm-collapsed', nowCollapsed);
        if (pagination) pagination.classList.toggle('pm-collapsed', nowCollapsed);
        loadmore.classList.toggle('pm-collapsed', nowCollapsed);
        if (sec && sec.classList) sec.classList.toggle('pm-only-best', nowCollapsed);
        btn.setAttribute('aria-expanded', nowCollapsed ? 'false' : 'true');
      });

      if (sec && sec.classList) sec.classList.add('pm-ready');

      function finish(handles) {
        var moved = 0, seen = {};
        (handles || []).forEach(function (h) {
          if (!h || seen[h]) return; seen[h] = 1;
          var card = list.querySelector('product-card[handle="' + cssEsc(h) + '"], .product-card[handle="' + cssEsc(h) + '"]');
          if (card) { bestGrid.appendChild(card); moved++; }
        });
        log('handles reçus :', (handles || []).length, '| cartes déplacées en tête :', moved);
        if (moved === 0) {
          var n = Math.min(4, cards.length - 1);
          for (var i = 0; i < n; i++) { bestGrid.appendChild(cards[i]); moved++; }
          log('aucun handle apparié -> repli sur', moved, 'premières cartes natives');
        }
        var others = Math.max(0, total - moved);
        sep.querySelector('.pm-n').textContent = others + ' autres résultats';
        if (others === 0) sep.style.display = 'none';
        log('OK - meilleures :', moved, '| autres :', others);
      }

      var sug = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
      fetch(sug, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var prods = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          log('prédictif :', prods.length, 'produits');
          if (prods.length) finish(prods.map(function (p) { return p.handle; }));
          else fallback();
        })
        .catch(function (e) { log('erreur prédictif', e); fallback(); });

      function fallback() {
        var preview = '';
        var m = location.search.match(/[?&]preview_theme_id=(\d+)/);
        if (m) preview = '&preview_theme_id=' + m[1];
        fetch('/search?q=' + encodeURIComponent(q) + '&view=pm-json&type=product' + preview, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.text(); })
          .then(function (t) {
            var d = {}; try { d = JSON.parse(t); } catch (e) {}
            var hs = (d.products || []).slice(0, 8).map(function (p) { return handleFromUrl(p.url); });
            log('repli plein-texte :', hs.length, 'produits');
            finish(hs);
          })
          .catch(function (e) { log('erreur repli', e); finish([]); });
      }

      function el(tag, cls) { var e = document.createElement(tag); e.className = cls; return e; }
      function cssEsc(s) { return String(s).replace(/["\\]/g, '\\$&'); }
      function handleFromUrl(u) { var m = String(u || '').match(/\/products\/([^?#\/]+)/); return m ? m[1] : ''; }
    } catch (e) {
      log('ERREUR', e && e.message ? e.message : e);
    }
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function boot() { whenReady(run); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
